import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCalendarAddComponent } from "./med-icon-calendar-add.component";

@NgModule({
  declarations: [
    MedIconCalendarAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCalendarAddComponent,
  ],
})
export class MedIconCalendarAddModule { }
